import * as React from "react";

const IconCaretUp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" transform="rotate(180)"><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S301 191.9 288 191.9L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg>};
export default React.memo(IconCaretUp);
